// import { ArrowRightOutlined, EditOutlined } from '@ant-design/icons';
import { TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { AgentFilterFormValuesPaginated } from 'features/agent/compoenents/top-bar/agent-filter-form';
import { usePermissions } from 'features/users';
// import { AddAdminUserModal } from 'features/users/components/modals/add-admin-user-modal';
// import { UserFilterFormValuesPaginated } from 'features/users/components/users-filter-form';
// import { useUpdateUserStatus } from 'features/users/use-cases/update-user';
import { Dispatch, SetStateAction} from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { User } from 'types';


type UsersTableProps = {
    isUsersListLoading: boolean;
    usersList: any;
    itemsCount: number;
    tableParams: AgentFilterFormValuesPaginated;
    updateParams: Dispatch<SetStateAction<AgentFilterFormValuesPaginated>>;
    adminUserEditData: any;
    setAdminUserEditData: any;
};

export const AgentTable = ({
    usersList,
    isUsersListLoading,
    itemsCount,
    tableParams,
    updateParams,
}: UsersTableProps) => {
    const { t } = useTranslation();
    const permissions = usePermissions();

    // const navigate = useNavigate();

    // const [showUpdateAdminModal, setShowUpdateAdminModal] = useState(false);
    // const [loadingSwitchId, setLoadingSwitchId] = useState('');

    // const { mutate: mutateUpdateUserStatus } = useUpdateUserStatus();

    if (!permissions) return null;

    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<User> | SorterResult<User>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    return (
        <StyledTableWrapper>
            <StyledTableHeader>
                <RecordCountBadge
                    text={t('AgentUser.heading.FounAgent')}
                    count={itemsCount}
                />
            </StyledTableHeader>

            <Table<User>
                loading={isUsersListLoading}
                dataSource={usersList}
                rowKey='id'
                onChange={handleTableChange}
                pagination={{
                    current: tableParams.page,
                    defaultPageSize: tableParams.size,
                    total: itemsCount,
                }}
            >
                <Column title={'UserId'} dataIndex={'UserId'} />
                <Column title={'Name'} dataIndex={'FullName'} />
                <Column title={'Action Type'} dataIndex={'LogType'} />
                <Column title={'Log Time stamp'} dataIndex={'LogTimestamp'} />
            </Table>
        </StyledTableWrapper>
    );
};